import React from "react";
import { Button, Modal } from 'react-bootstrap';
import Loader from 'components/Loader';

const LogOutDialog = ({ show, onClose, }) => {
  return (
    <Modal show={show} centered>
      <Modal.Header className="border-0"></Modal.Header>
      <Modal.Body className="text-center p-0">
        <Modal.Title className="mb-3">You are logging out...</Modal.Title>
        <Loader 
          width="30px"
          height="30px"
          variant="primary"
        />
      </Modal.Body>
      <Modal.Footer className="border-0">
        <Button variant="primary" onClick={onClose}>
          ok
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LogOutDialog;
